import PaginationObject from "../../../../src/mdx/api/schema/pagination-object.mdx";
import * as React from 'react';
export default {
  PaginationObject,
  React
};